import { motion } from "framer-motion";
import { ShieldCheck, Wallet, Timer, TrendingUp } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { IPhone } from "./PhoneMockups";

const Tile = ({ className = "", delay = 0, testId, children }) => (
  <Reveal delay={delay} className={className}>
    <motion.div whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 260, damping: 22 }} data-testid={testId} className="tile relative h-full overflow-hidden rounded-3xl bg-surface p-7 ring-1 ring-white/[0.07] md:p-9">
      {children}
    </motion.div>
  </Reveal>
);

const Head = ({ icon: Icon, title, text }) => (
  <>
    <Icon className="h-7 w-7 text-volt" />
    <h3 className="mt-6 font-display text-xl font-semibold text-paper md:text-2xl">{title}</h3>
    <p className="mt-3 max-w-sm text-sm leading-relaxed text-zinc-300 md:text-base">{text}</p>
  </>
);

export const Bento = ({ rates }) => {
  const best = rates.reduce((m, r) => Math.max(m, r.rate), 0);
  return (
    <section id="keunggulan" data-testid="features-section" className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-36">
      <Reveal>
        <SectionLabel index="03">Kenapa BagiPulsa</SectionLabel>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-bold leading-[1] tracking-tight text-paper md:text-6xl">Jasa convert pulsa <span className="text-outline">terpercaya.</span></h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-4 md:auto-rows-[260px]">
        <Tile className="md:col-span-2 md:row-span-2" testId="feature-terpercaya">
          <Head icon={ShieldCheck} title="Terpercaya" text="Sudah dipercaya oleh ribuan customer di Indonesia sebagai jasa tukar pulsa jadi uang." />
          <div className="spotlight pointer-events-none absolute inset-x-0 bottom-0 h-2/3" />
          <IPhone className="relative mx-auto mt-8 -mb-40 w-[62%] max-w-[260px] rotate-[8deg] md:absolute md:-bottom-60 md:right-10 md:mb-0 md:w-[38%]" />
        </Tile>
        <Tile className="md:col-span-2" delay={0.08} testId="feature-rate">
          <div className="flex h-full flex-col justify-between gap-6 md:flex-row md:items-end">
            <div><Head icon={TrendingUp} title="Rate Terbaik" text="Rate convert pulsa terbaik dan selalu update setiap harinya." /></div>
            <p className="font-display text-7xl font-bold leading-none tracking-tighter text-volt md:text-8xl">{best}<span className="text-4xl">%</span></p>
          </div>
        </Tile>
        <Tile delay={0.16} testId="feature-gratis">
          <Head icon={Wallet} title="Gratis Biaya Admin" text="Pencairan ke semua bank atau eWallet tanpa biaya apa pun." />
        </Tile>
        <Tile delay={0.24} testId="feature-cepat">
          <Head icon={Timer} title="Proses Cepat" text="Cukup 1 hingga 10 menit, pulsa kamu sudah jadi uang." />
        </Tile>
      </div>
    </section>
  );
};
